<template>
  <DsSpinnerModal :visible="loading" />
</template>

<script>
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { DsSpinnerModal } from '@ds/vue2';


export default {
  name: 'BaseLoader',
  components: {
    DsSpinnerModal
  },
  data () {
    return {
      loading: false
    }
  },
  beforeMount () {
    eventBus.$on('kaspiLoading', this.toggleLoading)
  },
  mounted () {
    this.toggleOverflow(this.loading)
  },
  updated () {
    this.toggleOverflow(this.loading)
  },
  beforeDestroy () {
    eventBus.$off('kaspiLoading', this.toggleLoading)
  },
  methods: {
    toggleLoading (loading) {
      this.loading = loading
    },
    toggleOverflow (bool) {
      if (bool) {
        document.getElementsByTagName('body')[0]
          .style.overflow = 'hidden'

        return
      }

      document.getElementsByTagName('body')[0]
        .style.overflow = 'auto'
    }
  }
}
</script>
